module.exports = __webpack_public_path__ + "img/confetti.3df6424.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/confetti.png
// module id = 139
// module chunks = 0